module.exports = __webpack_public_path__ + "img/22.d6a25803.png";